import { render } from "./ProductsShowcase.vue?vue&type=template&id=f8340b62&scoped=true"
import script from "./ProductsShowcase.vue?vue&type=script&lang=js"
export * from "./ProductsShowcase.vue?vue&type=script&lang=js"

import "./ProductsShowcase.vue?vue&type=style&index=0&id=f8340b62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8340b62"]])

export default __exports__